"use client";

import { useEffect } from "react";
import { AtlyLogo } from "@/components/atoms/AtlyLogo";
import Image from "next/image";
import classNames from "classnames";

export default function Error({ error, reset }) {
	useEffect(() => {
		// Log the error to an error reporting service
		console.error(error);
	}, [error]);

	return (
		<div className="w-screen h-screen flex items-center justify-center">
			<AtlyLogo className="fixed top-6 left-6 md:absolute md:top-6 md:mx-auto" />
			<div className="flex flex-col items-center justify-center">
				<Image
					src={"/assets/emptyMap.svg"}
					alt="Error"
					width={166}
					height={266}
				/>
				<p className="text-[19px] font-semibold text-center mt-5 mb-8 font-roboto max-w-64 leading-6 text-gray-800">
					Something went wrong, please try again
				</p>
				<div className="m-auto flex">
					<a
						href={"https://www.atly.com"}
						target="_blank"
						rel="noreferrer">
						<button
							className={classNames({
								"text-base h-10 rounded-full border cursor-pointer bg-white focus:outline-none": true,
								"border border-[#2171ec] hover:bg-[#d1e3ff]": true,
								"min-w-[184px]": true,
								"text-[#2171ec]": true,
							})}>
							Discover places in Atly
						</button>
					</a>
				</div>
			</div>
		</div>
	);
}
